export default __webpack_public_path__ + "static/media/iOS_store.2c44bf01.svg";